import { ComponentStyleConfig } from "@chakra-ui/react";

const CalendarDayTheme: ComponentStyleConfig = {
  baseStyle: {
    rounded: "20px",
    color: "gray.700",
    fontSize: "14px",
    fontWeight: "regular",
    border: 0,
    shadow: "none",
    minWidth: "40px",
    minHeight: "40px",
    _hover: {
      bg: "primary.50",
      fontWeight: 600,
    },
    _active: {
      bg: "primary.100",
      fontWeight: 600,
    },
  },
  variants: {
    outside: {
      color: "gray.500",
    },
    selected: {
      bgColor: "primary.600",
      color: "white",
      _hover: {
        bg: "primary.600",
      },
    },
    today: {
      bgColor: "gray.100",
      _hover: {
        bg: "gray.100",
      },
    },
    range: {
      color: "primary.800",
      bgColor: "primary.50",
    },
  },
};

export default CalendarDayTheme;
